import React from "react";
import Navbar from "../components/Navbar";
import "../css/PolicyPages.css";
import "../css/global.css";
import { useContacts } from "../context/ContactsContext";

// Last updated date for this policy
const LAST_UPDATED = "21/11/2025";

const CookiePolicy = () => {
  const { contacts } = useContacts();

  return (
    <div className="policy-page">
      <Navbar />
      <div className="policy-container">
        <h1>Cookie Policy</h1>
        <div className="policy-content">
          <p className="last-updated">Ultimo aggiornamento: {LAST_UPDATED}</p>

          <section>
            <h2>1. Cosa sono i Cookie</h2>
            <p>
              I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. 
              Questi file permettono al sito di riconoscere il tuo dispositivo e memorizzare alcune informazioni sulle tue preferenze o azioni passate.
            </p>
          </section>

          <section>
            <h2>2. Cookie Utilizzati da Questo Sito</h2>
            <p>
              <strong>Il nostro sito web non utilizza cookie di tracciamento, profilazione o pubblicitari.</strong>
            </p>
            <p>
              Utilizziamo esclusivamente un cookie tecnico strettamente necessario per memorizzare la tua preferenza 
              riguardo al consenso per la privacy policy e cookie policy. Questo cookie si chiama <code>fer-al-consent</code> 
              e serve unicamente a ricordare che hai letto e accettato le nostre politiche.
            </p>
          </section>

          <section>
            <h2>3. Tipologie di Cookie</h2>
            <h3>Cookie Tecnici (Strettamente Necessari)</h3>
            <p>
              Il nostro sito utilizza solo cookie tecnici essenziali per il funzionamento del sito:
            </p>
            <ul>
              <li>
                <strong>fer-al-consent:</strong> Memorizza il tuo consenso alle politiche del sito. 
                Questo cookie è strettamente necessario e non richiede il tuo consenso preventivo secondo la normativa vigente.
              </li>
            </ul>
            <p>
              <strong>Non utilizziamo:</strong>
            </p>
            <ul>
              <li>Cookie di profilazione</li>
              <li>Cookie pubblicitari</li>
              <li>Cookie di terze parti per tracciamento o analisi</li>
              <li>Cookie di social media</li>
            </ul>
          </section>

          <section>
            <h2>4. Durata dei Cookie</h2>
            <p>
              Il cookie <code>fer-al-consent</code> viene conservato per 365 giorni dalla tua ultima visita. 
              Dopo questo periodo, sarà necessario rinnovare il consenso.
            </p>
          </section>

          <section>
            <h2>5. Come Gestire i Cookie</h2>
            <p>
              Puoi gestire le preferenze sui cookie direttamente dal tuo browser. La maggior parte dei browser 
              permette di bloccare o eliminare i cookie. Tieni presente che la disabilitazione dei cookie tecnici 
              potrebbe influire sulla funzionalità del sito.
            </p>
            <p>Ecco come gestire i cookie nei browser più comuni:</p>
            <ul>
              <li><strong>Chrome:</strong> Impostazioni → Privacy e sicurezza → Cookie e altri dati dei siti</li>
              <li><strong>Firefox:</strong> Opzioni → Privacy e sicurezza → Cookie e dati dei siti web</li>
              <li><strong>Safari:</strong> Preferenze → Privacy → Cookie e dati dei siti web</li>
              <li><strong>Edge:</strong> Impostazioni → Privacy, ricerca e servizi → Cookie e autorizzazioni siti</li>
            </ul>
          </section>

          <section>
            <h2>6. Cookie di Terze Parti</h2>
            <p>
              Il nostro sito <strong>non utilizza cookie di terze parti</strong> per tracciamento, analisi o pubblicità.
            </p>
          </section>

          <section>
            <h2>7. Modifiche alla Cookie Policy</h2>
            <p>
              Ci riserviamo il diritto di modificare questa Cookie Policy in qualsiasi momento per riflettere 
              cambiamenti nelle nostre pratiche o per altri motivi operativi, legali o normativi. 
              Eventuali modifiche saranno pubblicate su questa pagina con la data di aggiornamento.
            </p>
          </section>

          <section>
            <h2>8. Contatti</h2>
            <p>
              Per qualsiasi domanda riguardante l'uso dei cookie sul nostro sito, puoi contattarci a:<br/>
              Email: <a href={`mailto:${contacts.CONTACT_EMAIL}`} className="link">{contacts.CONTACT_EMAIL}</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
